import { queryOptions, useQuery } from "@tanstack/react-query"
import axios from "axios"
import { ConversationTestingExperimentOptionsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

const EMPTY_OPTIONS: z.infer<typeof ConversationTestingExperimentOptionsResponseDataSchema> = []

type Response = DataResponse<z.infer<typeof ConversationTestingExperimentOptionsResponseDataSchema>>

const testingExperimentOptionsQuery = (enabled: boolean) =>
  queryOptions({
    queryKey: ["testingExperimentOptions"],
    enabled,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/conversations/testing/experiment-options", {
        signal,
      })
      return data.data
    },
  })

export function useTestingExperimentOptionsQuery(enabled: boolean) {
  const query = useQuery(testingExperimentOptionsQuery(enabled))

  return { ...query, data: query.data ?? EMPTY_OPTIONS }
}
